<template>
    <div class="w100">
        <vddl-list class="po-r pl10 pr10" v-for="(item, index) in list" :key="index" :list="item" :horizontal="true" :external-sources="false" :drop="handleDrop" :dragover="handleDragover">
            <vddl-draggable class="fl w16 po-r mt10 pt10 tx-c card-app" v-for="(val, key) in item" :key="val.keyId" :draggable="val" :index="key" :wrapper="item" effect-allowed="move" :moved="handleMoved">
                <i class="po-a grey del-x myfont icon-guanbi02 cu-p" @click.stop="delThisData(index, key)"></i>
                <img :src="!val.serveImage ? baseUrl + 'images/icon-app.png' : val.serveImage">
                <p class="mt10 font-14 pl10 pr10 ellipsis-2">{{ val.serveName }}</p>
            </vddl-draggable>
            <!-- <vddl-placeholder>拖动到此处</vddl-placeholder> -->
        </vddl-list>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    name: 'CardVddl',
    props: {
        listData: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            baseUrl: process.env.BASE_URL,
            list: {
                A: this.listData
            }
        };
    },
    created() {
        for (let i in this.list.A) {
            this.list.A[i].keyId = i;
        }
    },
    computed: {
        ...mapState(['userData'])
    },
    mounted() {},
    methods: {
        delThisData(index, key) {
            this.list[index].splice(key, 1);
        },
        handleDrop(data) {
            const { index, list, item } = data;
            item.keyId = new Date().getTime();
            list.splice(index, 0, item);
        },
        handleMoved(item) {
            const { index, list } = item;
            list.splice(index, 1);
        },
        handleDragover() {}
    }
};
</script>

<style scoped>
.del-x {
    right: 20%;
    top: 10px;
}

.card-app {
    min-height: 124px;
}

.del-x:hover {
    color: #333;
}

.vddl-list,
.vddl-draggable {
    position: relative;
}

.vddl-list {
    min-height: 134px;
}

.vddl-dragging-source {
    /* display: none; */
    opacity: 0.1;
}

.vddl-dragging {
    opacity: 0.7;
}

.vddl-placeholder {
    float: left;
    margin-top: 10px;
    width: 16.666667%;
    min-height: 124px;
    background: #efefef;
    border-radius: 4px;
    color: #999;
    line-height: 124px;
    text-align: center;
}

.vddl-list::after {
    content: '';
    clear: both;
    display: block;
    width: 100%;
    height: 0;
    visibility: hidden;
}
</style>